import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";

import type {
  GetAlumniCountRes,
  GetAlumniExportParams,
  GetAlumniExportRes,
  GetAlumniParams,
  GetAlumniRes,
} from "./type";

export const getAlumni = async (
  params: GetAlumniParams,
  isLeavingDateWithIn_A_Month?: boolean,
): Promise<GetAlumniRes> => {
  let leavingDateFrom: string | undefined;
  let leavingDateTo: string | undefined;
  if (isLeavingDateWithIn_A_Month) {
    const today = new Date();
    const lastMonth = new Date(today);
    lastMonth.setMonth(today.getMonth() - 1);
    leavingDateFrom = lastMonth.toISOString();
    leavingDateTo = today.toISOString();
  }

  const res = await apiClient.GET("/v2/alumnus", {
    params: {
      query: {
        ...params,
        leavingDateFrom,
        leavingDateTo,
      },
    },
  });
  return getDataOrThrowApiError(res);
};

export const getAlumniCount = async (): Promise<GetAlumniCountRes> => {
  const res = await apiClient.GET("/v2/alumnus/count");
  return getDataOrThrowApiError(res);
};

export const getAlumniExport = async (
  params: GetAlumniExportParams,
  isLeavingDateWithIn_A_Month?: boolean,
): Promise<GetAlumniExportRes> => {
  let leavingDateFrom: string | undefined;
  let leavingDateTo: string | undefined;
  if (isLeavingDateWithIn_A_Month) {
    const today = new Date();
    const lastMonth = new Date(today);
    lastMonth.setMonth(today.getMonth() - 1);
    leavingDateFrom = lastMonth.toISOString();
    leavingDateTo = today.toISOString();
  }

  console.log("leavingDateFrom", leavingDateFrom);
  console.log("leavingDateTo", leavingDateTo);
  const res = await apiClient.GET("/v2/people-csv/alumni", {
    params: {
      query: {
        ...params,
        mode: "view",
        encoding: "UTF-8",
        leavingDateFrom,
        leavingDateTo,
      },
    },
  });
  return getDataOrThrowApiError(res);
};
